module.exports = __webpack_public_path__ + "static/dashboardIcon-585e010f9a6373498ef7e75d22d0f329.png";